import {PENDING, FULFILLED} from '../actions/constants';
import * as EntryActions from "../actions/EntryActions";
import * as MessageActions from "../actions/MessageActions";
import * as TaskActions from "../actions/TaskActions";

export default (state = {

}, action) => {
    switch (action.type){

        case MessageActions.CLOSE_MESSAGE:
        case EntryActions.SAVE_ENTRY + PENDING:
        case EntryActions.REMOVE_ENTRY + PENDING:
            return null;

        case EntryActions.SAVE_ENTRY + FULFILLED:
            return {
                type: "success",
                title: "Success!",
                message: "Entry successfully saved."
            };

        case EntryActions.REMOVE_ENTRY + FULFILLED:
            return {
                type: "success",
                title: "Success!",
                message: "Entry successfully removed."
            };

        case TaskActions.SAVE_TASK + FULFILLED:
            return {
                type: "success",
                title: "Success!",
                message: "Task successfully saved."
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/MessageReducer.js